import "./index.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Bounce } from "react-awesome-reveal"

const TopNavAlert = () => {
  return (
    <div className="top-nav-alert" align="center">
      <Bounce>   <span>📰 New : Modern online and offline payments for Schools
        <FontAwesomeIcon icon={faArrowRight} className="icon" size="lg" /></span>
      </Bounce>

    </div>

  );
};

export default TopNavAlert;
